export const usdaCheckoutCapabilityStorageKey = (orderId) =>
  `usda_checkout_capability:${orderId}`;

function resolveStorage(storage) {
  if (storage !== undefined) return storage;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function persistUsdaCheckoutCapability(orderId, capability, storage) {
  storage = resolveStorage(storage);
  if (!orderId || !capability || !storage) return false;
  try {
    const key = usdaCheckoutCapabilityStorageKey(orderId);
    storage.setItem(key, capability);
    return storage.getItem(key) === capability;
  } catch {
    return false;
  }
}

export function readUsdaCheckoutCapability(orderId, storage) {
  storage = resolveStorage(storage);
  if (!orderId || !storage) return null;
  try {
    return storage.getItem(usdaCheckoutCapabilityStorageKey(orderId));
  } catch {
    return null;
  }
}

export function clearUsdaCheckoutCapability(orderId, storage) {
  storage = resolveStorage(storage);
  if (!orderId || !storage) return;
  try {
    storage.removeItem(usdaCheckoutCapabilityStorageKey(orderId));
  } catch {
    // Storage can be disabled by the browser; the server remains authoritative.
  }
}

export function usdaCheckoutRequestConfig(capability) {
  return capability
    ? { headers: { 'X-USDA-Checkout-Capability': capability } }
    : undefined;
}